import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface PutProductRequest {
    product_idx: number;
    product_category_idx: number;
    product_code_idx: number;
    product_name: string;
    product_amount: number;
    product_content?: string;
    product_memo?: string;
    status: boolean;
    del_file_idx?: number[];
    product_image?: File[];
    notice_image?: File[];
}

export const usePutGoods = (successCallback?: () => void): UseMutationResult<null, Error, PutProductRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, PutProductRequest>({
        mutationFn: async (productData: PutProductRequest) => {
            const formData = new FormData();
            formData.append("product_category_idx", productData.product_category_idx.toString());
            !isNaN(productData.product_code_idx) && formData.append("product_code_idx", productData.product_code_idx.toString());
            formData.append("product_name", productData.product_name);
            formData.append("product_amount", productData.product_amount.toString());
            formData.append("status", productData.status.toString());

            formData.append("product_content", productData.product_content || "");

            if (productData.product_memo) {
                formData.append("product_memo", productData.product_memo);
            }

            if (productData.del_file_idx && productData.del_file_idx.length > 0) {
                formData.append("del_file_idx", JSON.stringify(productData.del_file_idx));
            }

            if (productData.product_image) {
                productData.product_image.slice(0, 4).forEach(file => {
                    formData.append("product_image", file);
                });
            }

            if (productData.notice_image) {
                productData.notice_image.slice(0, 4).forEach(file => {
                    formData.append("notice_image", file);
                });
            }

            const response = await axios.put(`${enum_api_uri.put_product}/${productData.product_idx}`, formData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            return response.data.data;
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ["getGoodsList"] });
            queryClient.invalidateQueries({ queryKey: ["getGoodsInfo", variables.product_idx] });
            successCallback?.();
        },
    });
};
